import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { getSearchableCompanies } from "../../../../actions/company";
import Modal from "../../../common/Modal/Modal";
import CompanyListItem from "./CompanyListItem";
import SearchBar from "../../../common/SearchBar";
import { BRAND_NAME } from "../../../../brand";

export function RegFindCompany(props) {

    // when the component mounts, load array of all searchable companies to the global state
    useEffect(() => {
        props.getSearchableCompanies();
    }, []);

    // LOCAL STATE --------------------------------------------------------------------------------------------------------------------------
    const [searchResults, setSearchResults] = useState([]);

    // GLOBAL STATE --------------------------------------------------------------------------------------------------------------------------
    const searchableCompanies = useSelector(state => state.company.companies);
    const isCompanyDomainUnique = useSelector(state => state.auth.isCompanyDomainUnique);

    // to test styling, swap fakecompanies.filter for searchableCompanies.filter 
    const fakeCompanies = [
        {
            "id": 1,
            "name": "Company without Domain",
            "is_searchable": true,
            "has_domain": false,
            "domain": null,
            "icon_path": "/media/company/2b769fe3-d444-47f9-8478-851294429094/cologo_xyz.jpeg",
            "country": "Canada",
            "state": "Ontario",
            "city": "Toronto",
            "fk_industry": 1
        },
        {
            "id": 3,
            "name": "Company w Domain",
            "is_searchable": true,
            "has_domain": true,
            "domain": "4site.ai",
            "icon_path": "/media/company/90b0cc9b-8c63-405d-b9fb-af32c1eee474/cologo_generic.jpeg",
            "country": "Canada",
            "state": "Ontario",
            "city": "Toronto",
            "fk_industry": 1
        },
        {
            "id": 4,
            "name": "Canbim INC",
            "domain": null,
            "is_searchable": true,
            "has_domain": false,
            "icon_path": "/media/company/90b0cc9b-8c63-405d-b9fb-af32c1eee474/cologo_generic.jpeg",
            "country": "Canada",
            "state": "Ontario",
            "city": "Toronto",
            "fk_industry": 1
        },
        {
            "id": 5,
            "name": "Ellis Don",
            "domain": null,
            "is_searchable": true,
            "has_domain": false,
            "icon_path": "/media/company/90b0cc9b-8c63-405d-b9fb-af32c1eee474/cologo_generic.jpeg",
            "country": "Canada",
            "state": "Ontario",
            "city": "Toronto",
            "fk_industry": 1
        },
        {
            "id": 6,
            "name": "Little Guy Trades",
            "domain": null,
            "is_searchable": true,
            "has_domain": false,
            "icon_path": "/media/company/90b0cc9b-8c63-405d-b9fb-af32c1eee474/cologo_generic.jpeg",
            "country": "Canada",
            "state": "Ontario",
            "city": "Toronto",
            "fk_industry": 1
        },
        {
            "id": 7,
            "name": "Little Guy Trades",
            "domain": null,
            "is_searchable": true,
            "has_domain": false,
            "icon_path": "/media/company/90b0cc9b-8c63-405d-b9fb-af32c1eee474/cologo_generic.jpeg",
            "country": "Canada",
            "state": "Ontario",
            "city": "Toronto",
            "fk_industry": 1
        },
    ]

    // when text is input into the searchbar, filter the array of searchable companies and return only the companies containing a matching string (as search results)
    useEffect(() => {
        if (props.searchTerm !== null) {
            props.searchTerm === ""
            ? setSearchResults([])
            : setSearchResults(searchableCompanies.filter(company => company.name.toLowerCase().includes(props.searchTerm.toLowerCase())));
        } 
    }, [props.searchTerm]);

    // to create a company, give newCompany initial values. (the change from newCompany = null will trigger the modal stage change)
    const handleCreateCompany = () => {       
        const userDomain = props.newUser.email.split("@")[1];
        props.setNewCompany({...props.newCompanyInitial, phone: props.newUser.phone, domain: userDomain, register_domain: isCompanyDomainUnique});
        props.setStep("create company");
    }

    return (
        <Modal hasBackButton={true} handleBack={props.handleBack} className="login" >
            <div className="modal-content" >
                <p className="gap-below-m content2 light-black multiline text-center" >Connect to your company's {BRAND_NAME} account to complete your registration.</p>
                <div className="form-section" >
                    <SearchBar 
                        value={props.searchTerm ? props.searchTerm : ""} 
                        onChange={(e) => props.setSearchTerm(e.target.value)} 
                        placeholder="Search companies"
                        spacing="gap-below-s"
                        id="company_search"
                    />
                    <div className="company-list-wrapper" >
                        <div role="listbox" className={searchResults.length === 0 ? "company-list blank" : "company-list"} >
                        { (props.searchTerm && searchResults) &&
                            searchResults.map((company )=> {
                            return (
                                <CompanyListItem key={company.id} company={company} setSelectedCompany={props.setSelectedCompany} />
                            )
                        })}
                        {(props.searchTerm !== null && searchResults.length === 0) && <p className="content2 light no-companies" >No Companies match your search</p>}
                        </div>
                    </div>
                </div>
            </div>
            <p className="gap-above-l content2 light-black text-center gap-below-xs" >Company not yet registered with {BRAND_NAME}?</p>
            <button id="register_company" className="content2 text-center link1" onClick={() => handleCreateCompany()} tabIndex="0" >Register Company</button>
        </Modal>
    )
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {getSearchableCompanies})(RegFindCompany);
